import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DoctrineApiService } from '@modules/doctrine/doctrine-api.service';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';

@Component({
  selector: 'astrea-doctrine',
  templateUrl: './doctrine.component.html',
  styleUrls: ['./doctrine.component.scss']
})
export class DoctrineComponent implements OnInit {

  public doctrines!: any;
  public loading = true;
  public totalLength!: number;
  public itemsPerPage: number = 16;
  public filters = {
    limit: this.itemsPerPage,
    offset: 0
  };

  constructor(
    private route: ActivatedRoute,
    private api: DoctrineApiService,
    private seo: SeoMetadataService,
  ) { }

  ngOnInit(): void {
    this.setMetadata();
    this.route.queryParams
      .subscribe((params: Params) => {
        this.filters.offset = params.page ? (params.page-1)*this.itemsPerPage : 0;
        this.getBooks();
      });
  }

  setMetadata(): void {
    this.seo.setMetadata({
      title: `Doctrinas públicas | Editorial Astrea`,
      description: `Todas las doctrinas de lectura pública y gratuita que tenemos para ofrecerte.`
    });
  }

  getBooks(): void {
    this.loading = true;
    this.api.getBooks(this.filters)
      .subscribe(res => {
        this.doctrines = res.result.data;
        this.totalLength = res.result.total;
        this.loading = false;
      });
  }

}
